{
  "WHITE_LABEL": "",
  "APP_SCHEME": "partageclub",
  "APPLE_APP_ID": "1640792635",
  "CONTACT_EMAIL": "info@partage.club",
  "SUPPORTED_LANGUAGES": ["en", "fr", "es"],
  "FEATURE_FLAGS_ENABLED": ["freeSubPrograms", "guestAccess", "invite", "lastName", "listMembers", "measureImpact", "popularItemsByTags", "possibleActivationCodeDuringSignup", "predictions", "promptSharerType", "publishListings", "rateAfterLoans", "referralPrize", "showRecommendedForYou", "similarListings", "sso", "superSharer", "useNewOnboarding", "viewSubscription", "conciergerie", "streak"]
}
